import type { ReadTemplateDto } from '@goparrot/campaign-sdk';
import { PUSH_NOTIFICATION_TEMPLATE_UUID } from '../constants';

export const arePushNotificationCampaignsEnabled = (templates: ReadTemplateDto[]) => templates.some(({ uuid }) => uuid === PUSH_NOTIFICATION_TEMPLATE_UUID);
